module.exports = __webpack_public_path__ + "img/ic_order_canceled_staff_circle_filled.f399c360.png";